import { useIntl } from "react-intl";
import { ButtonVariant } from "~/components/atoms/Button/Buttons.types";
import OfferCard from "~/components/molecules/OfferCard/OfferCard";
import { Product } from "~/stores/checkout/product";

type CosmeticProductCardProps = {
  product: Product;
  isSelected?: boolean;
  onAdd?: (product: Product) => void;
};

const CosmeticProductCard = ({
  product,
  isSelected,
  onAdd,
}: CosmeticProductCardProps) => {
  const intl = useIntl();

  return (
    <OfferCard
      title={product.name}
      buttonText={
        isSelected
          ? intl.formatMessage({ id: "actions.added" })
          : intl.formatMessage({ id: "actions.add" })
      }
      buttonAction={() => onAdd?.(product)}
      buttonVariant={
        isSelected ? ButtonVariant.secondaryOutline : ButtonVariant.primary
      }
      hideImage
    >
      {/* <Subtitle level={2} className="text-grey-400">
        {product.name}
      </Subtitle> */}
    </OfferCard>
  );
};

export default CosmeticProductCard;
